<div #container></div>

<div class="right">
    @if (scriptStatus.error) {
    <span class="col-2 inline-block">{{scriptStatus.error}}</span>
    }
    @if (totalsUpdatingClickStatus.error) {
    <span class="col-2 inline-block">{{totalsUpdatingClickStatus.error}}</span>
    }
</div>
